function csrfTokenFromDocument(doc = document) {
	return doc.querySelector('meta[name="csrf-token"]')?.content || null
}

function patchCharteinstellungen({ kreditId, attributes, csrfToken = csrfTokenFromDocument(), fetchImpl = fetch }) {
	if (!csrfToken) return Promise.resolve()

	return fetchImpl(`/kredits/${kreditId}/charteinstellungen`, {
		method: "PATCH",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			"X-CSRF-Token": csrfToken,
		},
		body: JSON.stringify(attributes),
		credentials: "same-origin",
	})
}

export function speichereSerienSichtbarkeit({ kreditId, seriesId, visible, csrfToken, fetchImpl }) {
	return patchCharteinstellungen({
		kreditId,
		attributes: { series_id: seriesId, visible: visible },
		csrfToken,
		fetchImpl,
	})
}

export function speichereZeitachsenVariante({ kreditId, zeitachsenVariante, csrfToken, fetchImpl }) {
	return patchCharteinstellungen({
		kreditId,
		attributes: { zeitachsen_variante: zeitachsenVariante },
		csrfToken,
		fetchImpl,
	})
}
